<template>
  <div class="controls">
    <button v-on:click="togglePlay">
      <i class="fa play-pause" v-bind:class="{'fa-circle-o-notch': !soundcloud.ready, 'fa-play': !soundcloud.playing, 'fa-pause': soundcloud.playing}"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'player-controls',
  props: ['soundcloud'],
  methods: {
    backward: function () {
      this.soundcloud.api.prev()
      this.soundcloud.api.seekTo(0)
    },
    togglePlay: function () {
      this.soundcloud.api.toggle()
    },
    forward: function () {
      this.soundcloud.api.next()
      this.soundcloud.api.seekTo(0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ListenPage/PlayerControls.vue?6c959cb9